module.exports = __webpack_public_path__ + "img/header-479.ece04f7.png";